export default __webpack_public_path__ + "static/media/double-double-border-both.042be5b0.svg";